import type { Node } from 'slate';

import { Element } from 'slate';

import type { EmojiInline } from '@ui/MarkdownEditor/types';

export const type = 'gemoji';
export const isEmoji = (node: Node): node is EmojiInline => Element.isElementType(node, type);
